// In your dummyData/distributionPlan.ts
export const formatTime = (dateValue: any) => {
  if (!dateValue) return "Not set";
  
  try {
    let date: Date;
    
    // Handle Firestore timestamp format
    if (dateValue && typeof dateValue === 'object' && dateValue._seconds) {
      date = new Date(dateValue._seconds * 1000 + (dateValue._nanoseconds || 0) / 1000000);
    } 
    // Handle ISO string
    else if (typeof dateValue === 'string') {
      date = new Date(dateValue);
    }
    // Handle Date object
    else if (dateValue instanceof Date) {
      date = dateValue;
    } else {
      return "Not set";
    }
    
    return date.toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
  } catch (error) {
    console.error('Error formatting time:', error);
    return "Not set";
  };
};

// Get priority color class
export const getPriorityColor = (priority: string | null | undefined): string => {
  if (!priority) return 'cart-configuration-priority-unknown';
  
  // Handle both string and number priorities
  const priorityString = typeof priority === 'string' ? priority : String(priority);
  
  const priorityMap: Record<string, string> = {
    'highest': 'cart-configuration-priority-highest',
    'high': 'cart-configuration-priority-high',
    'medium': 'cart-configuration-priority-medium',
    'low': 'cart-configuration-priority-low',
    '1': 'cart-configuration-priority-highest',
    '2': 'cart-configuration-priority-high',
    '3': 'cart-configuration-priority-medium',
    '4': 'cart-configuration-priority-low'
  };
  
  return priorityMap[priorityString.toLowerCase()] || 'cart-configuration-priority-unknown';
};

// Get priority text
export const getPriorityText = (priority: string | null | undefined): string => {
  if (!priority) return 'Not Assigned';
  
  // Handle both string and number priorities
  const priorityString = typeof priority === 'string' ? priority : String(priority);
  
  const priorityMap: Record<string, string> = {
    'highest': 'Highest',
    'high': 'High',
    'medium': 'Medium',
    'low': 'Low',
    '1': 'Highest',
    '2': 'High',
    '3': 'Medium',
    '4': 'Low'
  };
  
  return priorityMap[priorityString.toLowerCase()] || 'Not Assigned';
};

// Calculate default priority based on distance
export const calculateDefaultPriority = (distance: number, allDistances: number[]): string => {
  if (allDistances.length === 0) return 'Medium';
  
  const maxDistance = Math.max(...allDistances);
  if (maxDistance === 0) return 'Medium';
  
  const normalizedDistance = distance / maxDistance;
  const priorityNumber = Math.ceil(normalizedDistance * 4); // Scale to 1-4
  
  const priorityMap: Record<number, string> = {
    1: 'Highest',
    2: 'High',
    3: 'Medium',
    4: 'Low'
  };
  
  return priorityMap[priorityNumber] || 'Medium';
};

// Sort priorities for proper ordering
export const getPrioritySortValue = (priority: string | null | undefined): number => {
  if (!priority) return 5; // Not assigned goes last
  
  // Handle both string and number priorities
  const priorityString = typeof priority === 'string' ? priority : String(priority);
  
  const priorityMap: Record<string, number> = {
    'highest': 1,
    'high': 2,
    'medium': 3,
    'low': 4,
    '1': 1,
    '2': 2,
    '3': 3,
    '4': 4
  };
  
  return priorityMap[priorityString.toLowerCase()] || 5;
};